/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

// ASSETS
import './CommunityFlagsForm.scss'

class CommunityFlagsForm extends Component {
  render() {
    const {
      formState,
      handleInputChange,
      toggleFormSection,
      createFlag,
      loader,
      isEdit,
      t,
    } = this.props
    return (
      <div id='CommunityFlagsForm' className='animated fadeIn'>
        <div className='rep-form-header'>
          <h4>
            {isEdit
              ? t('communities.flags.updateHeading')
              : t('communities.flags.createHeading')}
          </h4>
          <div className='form-btn-wrapper'>
            <button
              className='btn btn-primary'
              onClick={() => createFlag(isEdit ? 'update' : 'create')}
              disabled={loader || this._checkValidation()}
            >
              {loader && (
                <i className='fa fa-spinner fa-spin light-loading-spinner' />
              )}
              {isEdit
                ? loader
                  ? t('communities.flags.updatingFlag')
                  : t('communities.flags.updateFlag')
                : loader
                  ? t('communities.flags.addingFlag')
                  : t('communities.flags.addFlag')}
            </button>
            <button
              className='btn-dark-link'
              onClick={() => toggleFormSection('flags')}
              disabled={loader}
            >
              {t('common.cancel')}
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-12'>
                <label>
                  {t('communities.flags.currentRepresentative')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='representative_id'
                  name='representative_id'
                  onChange={handleInputChange}
                  value={formState.representative_id}
                  disabled={loader}
                >
                  <option value={-1} disabled>
                    {t('communities.flags.chooseCurrentRepresentative')}
                  </option>
                  {this._displayRepresentatives()}
                </select>
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-6'>
                <label>
                  {t('communities.flags.isThisResolved')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='is_resolved'
                  name='is_resolved'
                  onChange={handleInputChange}
                  value={formState.is_resolved}
                  disabled={loader}
                >
                  <option value={'unselected'} disabled>
                    {t('communities.flags.chooseAnswer')}
                  </option>
                  <option value={true}>{t('common.yes')}</option>
                  <option value={false}>{t('common.no')}</option>
                </select>
              </div>
              <div className='col-6'>
                <label>
                  {t('communities.flags.flagTypeLabel')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='flag_type'
                  name='flag_type'
                  onChange={handleInputChange}
                  value={formState.flag_type}
                  disabled={loader}
                >
                  <option value={'unselected'} disabled>
                    {t('communities.flags.chooseFlagType')}
                  </option>
                  <option value={'Credit Card Decline'}>
                    {t('communities.flags.flagType.creditCardDecline')}
                  </option>
                  <option value={'Annual Renewal Past Due'}>
                    {t('communities.flags.flagType.annualRenewalPastDue')}
                  </option>
                  <option value={'45 Days Past Due'}>
                    {t('communities.flags.flagType.fortyFiveDaysPastDue')}
                  </option>
                  <option value={'Verbally Going to Cancel'}>
                    {t('communities.flags.flagType.verballyGoingToCancel')}
                  </option>
                  <option value={'Needs Attention'}>
                    {t('communities.flags.flagType.needsAttention')}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <label>{t('communities.flags.flagNotesLabel')}</label>
            <textarea
              name='note'
              type='text'
              className='form-control'
              rows='5'
              label=''
              onChange={handleInputChange}
              placeholder={t('communities.flags.enterNotesPlaceholder')}
              value={formState.note}
              disabled={loader}
            />
          </div>
        </div>
      </div>
    )
  }

  _checkValidation = () => {
    const { formState } = this.props

    if (
      parseInt(formState.representative_id, 10) !== -1 &&
      formState.is_resolved !== 'unselected' &&
      formState.note !== '' &&
      formState.flag_type !== 'unselected'
    ) {
      return false
    }
    return true
  }

  _displayRepresentatives = () => {
    const { representatives } = this.props

    if (representatives && representatives.length > 0) {
      return representatives.map(rep => (
        <option value={rep.id} key={rep.id}>
          {rep.first_name} {rep.last_name}
        </option>
      ))
    }
    return null
  }

  _displayRepresentativeActionTypes = () => {
    const { representativeActionTypes } = this.props

    if (representativeActionTypes && representativeActionTypes.length > 0) {
      return representativeActionTypes.map(rep => (
        <option value={rep.id} key={rep.id}>
          {rep.name}
        </option>
      ))
    }
    return null
  }
}

export default withTranslation()(CommunityFlagsForm)
